export enum ConnectEvent {
  CREATED = 'TL_CONNECT_CREATED',
  UPDATED = 'TL_CONNECT_UPDATED',
}

export enum ConnectAction {
  LEAVE = 'LEAVE',
}
